var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inventory
    ? _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryWeight")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.weight,
                  expression: "inventory.weight"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryWeight").toString()
              },
              domProps: { value: _vm.inventory.weight },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "weight", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryVolume")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.volume,
                  expression: "inventory.volume"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryVolume").toString()
              },
              domProps: { value: _vm.inventory.volume },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "volume", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryPackage")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.package,
                  expression: "inventory.package"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryPackage").toString()
              },
              domProps: { value: _vm.inventory.package },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "package", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventorySize")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.size,
                  expression: "inventory.size"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventorySize").toString()
              },
              domProps: { value: _vm.inventory.size },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "size", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventorySupplierContact")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.supplierContact,
                  expression: "inventory.supplierContact"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventorySupplierContact").toString()
              },
              domProps: { value: _vm.inventory.supplierContact },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "supplierContact",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventorySupplierNumber")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.supplierNumber,
                  expression: "inventory.supplierNumber"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventorySupplierNumber").toString()
              },
              domProps: { value: _vm.inventory.supplierNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "supplierNumber", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryOrigin")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.origin,
                  expression: "inventory.origin"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryOrigin").toString()
              },
              domProps: { value: _vm.inventory.origin },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "origin", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryHSCode")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.hsCode,
                  expression: "inventory.hsCode"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryHSCode").toString()
              },
              domProps: { value: _vm.inventory.hsCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "hsCode", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryQuality")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.quality,
                  expression: "inventory.quality"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryQuality").toString()
              },
              domProps: { value: _vm.inventory.quality },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "quality", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryQuality2")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.quality2,
                  expression: "inventory.quality2"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryQuality2").toString()
              },
              domProps: { value: _vm.inventory.quality2 },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "quality2", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryPartNumber")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.partNumber,
                  expression: "inventory.partNumber"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryPartNumber").toString()
              },
              domProps: { value: _vm.inventory.partNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "partNumber", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryWeb")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.web,
                  expression: "inventory.web"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryWeb").toString()
              },
              domProps: { value: _vm.inventory.web },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "web", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvDefaultActionAmount")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.defaultActionAmount,
                  expression: "inventory.defaultActionAmount"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvDefaultActionAmount").toString()
              },
              domProps: { value: _vm.inventory.defaultActionAmount },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "defaultActionAmount",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm.inventory.isShowPackageCount
              ? _c("div", [
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.$t("maintenance.inventory.model.packageCount"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inventory.packagesCount,
                        expression: "inventory.packagesCount"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: _vm
                        .$t("maintenance.inventory.model.packageCount")
                        .toString()
                    },
                    domProps: { value: _vm.inventory.packagesCount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.inventory,
                          "packagesCount",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("small", [
              _vm._v(_vm._s(_vm.$t("maintenance.inventory.model.inboundPrice")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.inventory.inboundPrice,
                  expression: "inventory.inboundPrice",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                placeholder: _vm
                  .$t("maintenance.inventory.model.inboundPrice")
                  .toString()
              },
              domProps: { value: _vm.inventory.inboundPrice },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "inboundPrice",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("small", [
              _vm._v(_vm._s(_vm.$t("maintenance.inventory.model.storagePrice")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.inventory.storagePrice,
                  expression: "inventory.storagePrice",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                placeholder: _vm
                  .$t("maintenance.inventory.model.storagePrice")
                  .toString()
              },
              domProps: { value: _vm.inventory.storagePrice },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "storagePrice",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("small", [
              _vm._v(
                _vm._s(_vm.$t("maintenance.inventory.model.outboundPrice"))
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.inventory.outboundPrice,
                  expression: "inventory.outboundPrice",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                placeholder: _vm
                  .$t("maintenance.inventory.model.outboundPrice")
                  .toString()
              },
              domProps: { value: _vm.inventory.outboundPrice },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "outboundPrice",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group form-check mt-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inventory.isShowPictureInLine,
                    expression: "inventory.isShowPictureInLine"
                  }
                ],
                staticClass: "form-check-input",
                staticStyle: {
                  transform: "scale(1.75)",
                  "margin-left": "-1rem"
                },
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.inventory.isShowPictureInLine)
                    ? _vm._i(_vm.inventory.isShowPictureInLine, null) > -1
                    : _vm.inventory.isShowPictureInLine
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.inventory.isShowPictureInLine,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.inventory,
                            "isShowPictureInLine",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.inventory,
                            "isShowPictureInLine",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.inventory, "isShowPictureInLine", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "0.625rem" } }, [
                _c("small", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("maintenance.inventory.model.isShowPictureInLine")
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group form-check mt-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inventory.isShowPackageCount,
                    expression: "inventory.isShowPackageCount"
                  }
                ],
                staticClass: "form-check-input",
                staticStyle: {
                  transform: "scale(1.75)",
                  "margin-left": "-1rem"
                },
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.inventory.isShowPackageCount)
                    ? _vm._i(_vm.inventory.isShowPackageCount, null) > -1
                    : _vm.inventory.isShowPackageCount
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.inventory.isShowPackageCount,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.inventory,
                            "isShowPackageCount",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.inventory,
                            "isShowPackageCount",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.inventory, "isShowPackageCount", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "0.625rem" } }, [
                _c("small", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("maintenance.inventory.model.isShowPackageCount")
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group form-check mt-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inventory.isNegativStockAllowed,
                    expression: "inventory.isNegativStockAllowed"
                  }
                ],
                staticClass: "form-check-input",
                staticStyle: {
                  transform: "scale(1.75)",
                  "margin-left": "-1rem"
                },
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.inventory.isNegativStockAllowed)
                    ? _vm._i(_vm.inventory.isNegativStockAllowed, null) > -1
                    : _vm.inventory.isNegativStockAllowed
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.inventory.isNegativStockAllowed,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.inventory,
                            "isNegativStockAllowed",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.inventory,
                            "isNegativStockAllowed",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.inventory, "isNegativStockAllowed", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "0.625rem" } }, [
                _c("small", [_vm._v(_vm._s(_vm.$t("txtInvAllowNegativStock")))])
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }